import {
  VIBE_CODING_PREVIEW_ENSURE_BEGIN,
  VIBE_CODING_PREVIEW_ENSURE_FAILURE,
  VIBE_CODING_PREVIEW_ENSURE_SUCCESS,
} from './constants';
import { fetchEnsureWorkspacePreview } from '../services/vibeCodingService';

export const ensureWorkspacePreview =
  (args = {}) =>
  async (dispatch) => {
    dispatch({
      type: VIBE_CODING_PREVIEW_ENSURE_BEGIN,
      data: {
        projectId: args.projectId,
        version: args.version,
        rebuild: Boolean(args.rebuild),
        reinstall: Boolean(args.reinstall),
      },
    });

    try {
      const data = await fetchEnsureWorkspacePreview(args);

      if (data && data.status === 'error') {
        const error = new Error(data.error || 'Preview failed');
        dispatch({
          type: VIBE_CODING_PREVIEW_ENSURE_FAILURE,
          data: { error },
        });
        throw error;
      }

      dispatch({
        type: VIBE_CODING_PREVIEW_ENSURE_SUCCESS,
        data,
      });
      return data;
    } catch (error) {
      dispatch({
        type: VIBE_CODING_PREVIEW_ENSURE_FAILURE,
        data: { error },
      });
      throw error;
    }
  };

export function reducer(state, action) {
  switch (action.type) {
    default:
      return state;
  }
}
